<div class="sut-nav-stepper-wrapper flex flex-row bg-white rounded-lg" [class.drop-shadow]="dropShadow">
  <div class="sut-nav-stepper-header-container flex flex-col w-[236px]">
    <ng-container *ngFor="let step of steps; let i = index">
      <sut-nav-step-header
        [selected]="isSelected(i)"
        [label]="step.label"
        [index]="i"
        (click)="step.select()"
        [completed]="step.completed"
        [hasError]="step.hasError"
        [errorMessage]="step.errorMessage"
        [severity]="step.severity"
      />
    </ng-container>
  </div>

  <mat-divider [vertical]="true" />

  <div class="p-6 w-full">
    <div *ngFor="let step of steps; let i = index">
      <ng-container *ngIf="isSelected(i)" [ngTemplateOutlet]="step.content" />
    </div>
  </div>
</div>
